var youbora = require('youboralib');

var manifest = require('../../manifest.json');

var GenericAdsAdapter = youbora.Adapter.extend({
  getVersion: function getVersion() {
    return manifest.version + '-videojs-ads';
  },
  registerListeners: function registerListeners() {
    // Register listeners
    this.references = [];
    this.references['adstart'] = this.adStartListener.bind(this);
    this.references['adend'] = this.adEndListener.bind(this);
    this.references['adskip'] = this.adSkipListener.bind(this);
    this.references['adserror'] = this.errorListener.bind(this);
    this.references['ads-click'] = this.clickListener.bind(this);
    if (this.player) Object.keys(this.references).forEach(function (key) {
      this.player.on(key, this.references[key]);
    }.bind(this));
  },
  adStartListener: function adStartListener(e) {
    this.fireStart();
    this.fireJoin();
  },
  adEndListener: function adEndListener(e) {
    this.fireStop();
  },
  adSkipListener: function adSkipListener(e) {
    this.fireStop({
      skipped: true
    });
  },
  errorListener: function errorListener(e) {
    this.fireError('Ad error');
  },
  clickListener: function clickListener(e) {
    this.fireClick();
  },
  unregisterListeners: function unregisterListeners() {
    // unregister listeners
    if (this.player && this.references) {
      if (this.player) Object.keys(this.references).forEach(function (key) {
        this.player.off(key, this.references[key]);
      }.bind(this));
      this.references = [];
    }
  }
});
module.exports = GenericAdsAdapter;